import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PlaybackSection = styled(Box)({
  marginTop: 24,
  marginBottom: 8,
});
